import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { catchError, throwError, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const AUTH_STORAGE_KEY = 'scalex_auth';
  const injector = inject(Injector);

  let token: string | null = null;
  try {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      token = parsed.token;
    }
  } catch (error) {
    console.error('Error in auth interceptor:', error);
  }

  // Clone request with token if available and header not set
  if (token && !req.headers.has('Authorization')) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // If 401 and NOT a refresh request and NOT a login request and NOT a logout request
      if (error.status === 401 && !req.url.includes('/auth/refresh') && !req.url.includes('/auth/login') && !req.url.includes('/auth/logout')) {
        const authService = injector.get(AuthService);

        // Try refresh
        return authService.refreshTokenRequest().pipe(
          switchMap((response) => {
            // Update request with new token
            const newReq = req.clone({
              setHeaders: { Authorization: `Bearer ${response.token}` }
            });
            return next(newReq);
          }),
          catchError((refreshErr) => {
            // If refresh fails, logout
            authService.logout(true);
            return throwError(() => refreshErr);
          })
        );
      }

      // If a refresh request fails with 401, we must logout
      if (error.status === 401 && req.url.includes('/auth/refresh')) {
        const authService = injector.get(AuthService);
        authService.logout(true);
      }

      // For other 401s (login, logout), just propagate the error. 
      // We do NOT want to force logout on a failed logout call (infinite loop).

      return throwError(() => error);
    })
  );
};
